// extracted by mini-css-extract-plugin
export var active = "categories-module--active--KHzHz";
export var categoriesBlock = "categories-module--categoriesBlock--WRSxa";
export var hasSearchBar = "categories-module--hasSearchBar--0t2zi";
export var item = "categories-module--item--ahRVF";
export var overflow = "categories-module--overflow--vVDBm";
export var sbShowMain = "categories-module--sb-show-main--PePHG";
export var sidebar = "categories-module--sidebar--3KbSR";
export var withDivider = "categories-module--withDivider--jycuB";
export var wrapper = "categories-module--wrapper--tM6u6";